"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavListItem;
const react_1 = __importDefault(require("react"));
const index_1 = require("../../../index");
const styles_1 = require("@material-ui/styles");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, styles_1.makeStyles)({
    container: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    selected: {
        color: index_1.StyleVariables.colors.text.info,
        fontWeight: index_1.StyleVariables.fonts.weight.semiBold,
        cursor: 'pointer',
    },
    notSelected: {
        color: index_1.StyleVariables.colors.text.default,
        marginLeft: index_1.StyleVariables.spacing(1.75),
        cursor: 'pointer',
    },
    verticalLine: {
        marginRight: index_1.StyleVariables.spacing(1),
        width: index_1.StyleVariables.spacing(0.75),
        height: index_1.StyleVariables.spacing(3),
        backgroundColor: index_1.StyleVariables.colors.icon.info,
    },
});
function NavListItem({ label, isSelected = false, className, ...rest }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)([className, classes.container]), ...rest },
        isSelected && react_1.default.createElement("div", { className: classes.verticalLine }),
        react_1.default.createElement(index_1.Text, { "data-testid": "nav-item-label", className: isSelected ? classes.selected : classes.notSelected, as: isSelected ? 'h6' : 'p' }, label)));
}
